// https://vuex.vuejs.org/en/state.html

export default {
  //
  displaySidebar: true,
  displayMainToolbar: true,
  displayWebsiteToolbar: false,
  // theme: localStorage.getItem('theme') || 'theme-a',
  error: null,
  success: null,
  delete: null,
  loading: false,
};
